const HLS_JS_DEFAULTS = {
    debug: false,
    enableCEA708Captions: true,
    enableWebVTT: false,
    // autoStartLoad: true,
    // defaultAudioCodec: 'mp4a.40.2
};

export default HLS_JS_DEFAULTS;


// WEBPACK FOOTER //
// ./src/config/hls-js-defaults.js